<template>
    <div>
      <div class="slide mb-5">
        <div class="bg-img">
          <div class="slide-content">
            <h2 class="slide-header">{{ 'Purchases' }}</h2>
            <div>
              <h5 class="slide-h5">{{ $t('message.home') }}</h5>
              <b-icon :icon="isRTL ? 'chevron-double-left' : 'chevron-double-right'" class="icon-slider"></b-icon>
              <h5 class="slide-h5">{{ 'Purchases' }}</h5>
            </div>
          </div>
        </div>
      </div>

      <div class="container mt-5">

        <!-- جدول الطلبات -->
      <b-table :items="orders" hover responsive class="custom-body mb-3" :fields="fields"
        @row-clicked="showInovicesDetails"
      >


        <template #cell(technical)="data">
          <b-badge style="border-radius: 6px; padding: 5px; width: 50px;" variant="info">
            {{ data.item.technical }}
          </b-badge>
        </template>

        <template #cell(actions)="data">
          <b-button size="sm" class="ml-2 store-action-btn printInvoice btn-success"
            @click="printInvoice(data.item)">🖨 Print</b-button>
        </template>
      </b-table>


      <!-- تفاصيل الفتوره -->
      <b-modal scrollable size="xl" id="orderInvoiceModal" title="Order Details" class="custom-modal">
        

        <div ref="printSection" class="invoice-container">
        <b-card class="invoice-card p-4">
          <!-- Header -->
          <div class="invoice-header">
            <div class="company-info">
              <!-- <img src="@/assets/logo-medium.png" alt="Company Logo" class="company-logo"> -->
              <h2>{{this.company.companyName}}</h2>
              <!-- <p>123 Street, City, Country</p> -->
              <p>Phone: {{ this.company.companyPhone }}</p>
              <p>Email: {{ this.company.companyEmail }}</p>
            </div>
            <div class="invoice-details text-right">
              <h3>Purchase Order</h3>
              <p><strong>Date:</strong> {{ new Date().toLocaleDateString() }}</p>
              <p><strong>Invoice ID:</strong> {{ order.id }}</p>
            </div>
          </div>
  
  
          <hr>
  
          <!-- Order & Customer Details -->
          <b-row class="mt-4">
            
            <b-col md="12" class="customer-details">
              <h5 class="section-title">Customer Details</h5>
              <p><strong>Name:</strong> {{ order.customerName }}</p>
              <p><strong>Email:</strong> {{ order.customerEmail }}</p>
              <p><strong>Phone:</strong> {{ order.customerPhone }}</p>
            </b-col>
          </b-row>
  
          <hr>
  
          <!-- Table -->
          <b-table  responsive bordered class="invoice-table mt-4 custom-body" :items="inoviceItems" :fields="invoiceFields" >
            <template #cell(quantityAvilableStore)="data">
              <span>{{ data.item.quantityAvilableStore }}</span>
              
            </template>
           
            
          </b-table>
  
  
          <!-- Total & Print Button -->
          <div class="text-right mt-4">
            <!-- <h4 class="total"><strong>Total: ${{ order.total }}</strong></h4> -->
            <b-button variant="success" class="print-btn mt-3" @click="print">🖨 Print PR</b-button>
            <!-- <b-button variant="primary" class="share-btn mt-3" @click="shareInvoice">📤 Share</b-button> -->
          </div>
        </b-card>
      </div>

        <!-- Footer Buttons -->
        <template #modal-footer>
          <b-button variant="secondary" class="rounded-btn" @click="$bvModal.hide('orderInvoiceModal')">Close</b-button>
          
        </template>
      </b-modal>

      </div>
    </div>
</template>
<script>
 import axiosInstance from '../axios-config';
  import { mapGetters } from 'vuex'
  import vSelect from 'vue-select';
  import 'vue-select/dist/vue-select.css';
export default {
    components: {
      vSelect
    },
    data() {
      return {
        orders: [

      ],
      fields: [
        { key: "id", label: "Order id" },
        { key: "name", label: "Technical Responsible" },
        { key: "phone", label: "Phone" },
        { key: "supplyOrderCount", label: "#invoices" },
        { key: "actions", label: "Actions" },
      ],
      selectedOrder: {},
      order: {
        id: "#123456",
        productType: "Laptop",
        quantity: 2,
        customerName: "John Doe",
        customerEmail: "johndoe@example.com",
        customerPhone: "123-456-7890",
        total: 1500,
      },
        
        company: {
          companyName: '',
          companyEmail: '',
          companyPhone: '',
  
        },
        inoviceItems: [],
        
        invoiceFields: [
          { key: "id", label: "Order ID" },
          { key: "itemId", label: "Item ID" },
          { key: "itemDescEN", label: "Product" },
          { key: "poiQuantity", label: "Required Quantity" },
          { key: "itemQty", label: "Available Quantity" },
          { key: "quantityAvilableStore", label: "Remaining Quantity" },
        //   { key: "actions", label: "Actions" },
        ],
      }
    },
    computed: {
      ...mapGetters(['getUser']),
      company_id() {
        return this.getUser; // استخدام الـ getter لجلب بيانات المستخدم
      },
      isRTL() {
        return this.$i18n.locale === 'ar';
      },
      
      
  
    },
    methods:{
      showInovicesDetails(order) {
        console.log(order);

        // تخزين الـ order في Vuex و localStorage
        this.$store.dispatch('setOrder', order);

        // الانتقال إلى صفحة الفواتير
        this.$router.push(`/order/${order.id}/invoices`);
      },

      async fetchData() {
      try {
        const response = await axiosInstance.get('store/select_parchease_request.php', {
          params: {
            company_id: this.company_id.company_id,
            status: 1 // إرسال الحالة المختارة إلى API
          }
        });
        

        


        console.log("Response Data:", response.data);
        if (response.data.status === "true") {
          this.orders = response.data.output; // التأكد من تحديث orders
        } else {
          this.orders = []; // لو مفيش بيانات، خليها فاضية
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        this.$izitoast.error({
          title: 'Error',
          message: 'An error occurred while trying to get data',
          position: 'bottomLeft',
          timeout: 5000,
        });
      }
    },

    async printInvoice(order){
      try {
          this.selectedOrder = order; // حفظ البيانات الأساسية
          const response = await axiosInstance.get(`store/select_order_invoice_pr.php`, {
            params: {
              company_id: this.company_id.company_id,
              purchase_id: order.id
            }
          });

          if (response.data.status === "true") {
            this.inoviceItems = response.data.output.items.filter(item => item.itemStatus == 0);
            this.order.customerName = response.data.output.technical.name;
            this.order.customerEmail = response.data.output.technical.email;
            this.order.customerPhone = response.data.output.technical.phone;
            this.company.companyName = response.data.output.company.name;
            this.company.companyEmail = response.data.output.company.email;
            this.company.companyPhone = response.data.output.company.phone;
            this.$bvModal.show("orderInvoiceModal"); // فتح المودال
          } else {
            this.$izitoast.error({
              title: 'Error',
              message: 'Failed to fetch order details',
              position: 'bottomLeft',
              timeout: 5000,
            });
          }
        } catch (error) {
          console.error('Error fetching order details:', error);
          this.$izitoast.error({
            title: 'Error',
            message: 'An error occurred while fetching order details',
            position: 'bottomLeft',
            timeout: 5000,
          });
        }
    },
    print() {
    const content = this.$refs.printSection.innerHTML;
    const printWindow = window.open('', '', 'width=800,height=900');

    printWindow.document.write(`
      <html>
        <head>
          <title>Print Invoice</title>
          <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css">
          <style>
            body {
              padding: 20px;
              font-family: Arial, sans-serif;
            }
            .invoice-card {
              border: none;
              box-shadow: none;
            }
          </style>
        </head>
        <body onload="window.print(); window.close();">
          ${content}
        </body>
      </html>
    `);

    printWindow.document.close();
  }
    },
    mounted() {
    this.fetchData();
  },
}

</script>

<style scoped>
.custom-modal .modal-content {
  border-radius: 10px !important;
  padding: 15px;
  background: #f8f9fa;
}
</style>